import React from 'react';
import Modal from 'react-bootstrap/Modal';
import colors from 'styles/colors';
import CompanyDetails from 'components/molecules/company_details';

interface ProvidersModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setCurrentPageBidding: React.Dispatch<React.SetStateAction<number>>;
  currentPageBidding: number;
}

const ProvidersModal = (props: ProvidersModalProps) => {
  const { showModal, setShowModal, setCurrentPageBidding, currentPageBidding } = props;

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Concorrente</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <CompanyDetails
              setCurrentPageBidding={setCurrentPageBidding}
              currentPageBidding={currentPageBidding}
            />
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProvidersModal;
